import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
  Button,
  TextField,
} from '@material-ui/core';
import throttle from 'lodash/throttle';
import {
  searchSourceBook,
  setMainBook as apiSetMainBook, setQuotesSourceBook
} from '../../services/api';
import BookOptions from './BookOptions';

const BookSelector = ({ book, userStore, onSave }) => {
  const [newBook, setNewBook] = useState(null);
  const [saved, setSaved] = useState(true);

  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);

  const [sending, setSending] = useState(false);
  const inputRef = useRef();

  const search = useMemo(() => throttle(async (term, callback) => {
    const result = await searchSourceBook(userStore.token, term);
    const list = [];

    if (!result.data.data) {
      return;
    }

    for (let data of result.data.data) {
      list.push(data);
    }
    callback(list)
  }, 1000), []);

  useEffect(() => {
    if (inputValue.length < 1) {
      setOptions([]);
      return;
    }
    search(inputValue, (results) => setOptions(results));
  }, [inputValue]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setSaved(false);
  };

  const onSelect = (book) => {
    setNewBook(book);
    inputRef.current.blur();
  };

  const reset = () => {
    setTimeout(() => {
      setOptions([]);
      setInputValue('');
    }, 100);
  }

  const getLabel = (book) => {
    if (!book) {
      return '';
    }

    return `ID ${ book.book_id } - ${ book.title } - ${ book.authors }  - ISBN ${ book.isbn }`;
  };

  return (
    <form>
      <TextField
        sx={ { width: 210 } }
        ref={ inputRef }
        label='Livro-filho'
        type='text'
        focused={ saved }
        size='small'
        InputLabelProps={ { shrink: true } }
        onChange={ handleChange }
        onFocus={ () => setNewBook(null) }
        onBlur={ () => reset()}
        value={ newBook ? getLabel(newBook) : inputValue }
        autoFocus
      />
      <BookOptions opened={ options.length > 0 && !newBook }
                       bookList={ options } anchorEl={ inputRef.current }
                       onSelect={ onSelect } />
      <Button
        disabled={ sending }
        size='large'
        type='button'
        onClick={ () => {
          onSave(newBook)
        } }
      >
        Mover
      </Button>
    </form>
  )
}

export default BookSelector;
